import { Pagination } from "ant-design-vue";
import "./src/pagination.less"
const { ...other } = Pagination;
const YwPagination = {
	...other,
	name: "YwPagination",
};

YwPagination.install = function (Vue) {
	Vue.component(YwPagination.name, Pagination);
};

export default YwPagination;
